import { Button } from '@mui/material';
import { useRouter } from 'next/router';

export const ProductIntroductionButton = () => {
  const router = useRouter();

  return (
    <Button 
      fullWidth
      variant="contained" 
      onClick={() => router.push('/intro')}
      sx={{
        backgroundColor: '#FF9800',
        color: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        minHeight: '48px',
        borderRadius: '24px',
        boxShadow: '0 4px 16px rgba(255, 152, 0, 0.3)',
        textTransform: 'none',
        position: 'relative',
        overflow: 'hidden',
        transition: 'all 0.3s ease',
        display: 'flex',
        justifyContent: 'center',
        '&:hover': {
          backgroundColor: '#F57C00',
          transform: 'translateY(-1px)',
          boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
        },
        '&:active': {
          transform: 'translateY(0px)',
          boxShadow: '0 2px 8px rgba(255, 152, 0, 0.3)',
        },
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '50%',
          left: '50%',
          width: '0',
          height: '0',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.2)',
          transform: 'translate(-50%, -50%)',
          transition: 'width 0.3s, height 0.3s',
        },
        '&:hover::before': {
          width: '100%',
          height: '100%',
        }
      }}
    >
      产品介绍
    </Button>
  );
};
